import { useMemo } from 'react';
import { UseFormHandleSubmit } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { childrenTaskPageBreadcrumbs } from '../../config';
import { TaskForm } from '../../components';
import { useTaskActions } from '../../hooks';
import { defaultTaskValues, TaskSchema } from '../../schemas';
import { FormSubmitButton, NavigateLinks } from '@/components';

const CreateTask = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(() => childrenTaskPageBreadcrumbs(navigate), []);

  const { onCreateTask, isCreateTaskLoading } = useTaskActions();

  const onSubmit = (data: TaskSchema, reset: () => void) => {
    onCreateTask(data, reset);
  };

  const renderButtons = (
    handleSubmit: UseFormHandleSubmit<TaskSchema>,
    reset: () => void
  ) => (
    <div className='flex justify-between'>
      <FormSubmitButton
        icon={' '}
        label='Cancelar'
        action={() => navigate('/tasks')}
        isLoading={false}
      />
      <FormSubmitButton
        icon={' '}
        label='Crear Tarea'
        action={handleSubmit((data: TaskSchema) => onSubmit(data, reset))}
        isLoading={isCreateTaskLoading}
      />
    </div>
  );

  return (
    <div className='flex flex-col w-full h-full gap-10'>
      <NavigateLinks actualPage='Crear Tarea' breadcrumbs={breadcrumbs} />
      <TaskForm
        action={onSubmit}
        defaultValues={defaultTaskValues}
        renderButtons={renderButtons}
      />
    </div>
  );
};

export default CreateTask;
